import React from 'react'
import { createNgReactBridgeDirective } from '../../../react-bridge'
import { EmailDomainsSecuritySection } from '../../../../components/security/email-domains-security-section'

function ReactEmailDomainsSecuritySection({ organizationID }) {
  if (typeof organizationID !== 'string') {
    throw new Error('organizationID is required')
  }

  return <EmailDomainsSecuritySection organizationID={organizationID} />
}

export const reactEmailDomainsSecuritySection = createNgReactBridgeDirective(
  'reactEmailDomainsSecuritySection',
  [],
  ReactEmailDomainsSecuritySection,
  ['organizationID']
)
